import React from 'react'
import { Layout } from 'antd'
import { Switch, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import SideNav from 'components/layout-components/SideNav'
import TopNav from 'components/layout-components/TopNav'
import MobileNav from 'components/layout-components/MobileNav'
import HeaderNav from 'components/layout-components/HeaderNav'
import PageHeader from 'components/layout-components/PageHeader'
import Footer from 'components/layout-components/Footer'
import navigationConfig from 'configs/NavigationConfig'
import { NAV_TYPE_TOP } from 'constants/ThemeConstant'
import utils from 'utils'
import { useGetTenantId } from 'hooks/useGetTenantId'
import { CMSContextProvider } from 'views/cm-views/utils/cmsContextProvider'

const { Content } = Layout

export const CustomLayout = ({ navType, location, views }) => {
  const tenantId = useGetTenantId()
  //localStorage.setItem('tenantId', tenantId)
  const currentRouteInfo = utils.getRouteInfo(navigationConfig('/app', tenantId), location.pathname)
  console.log('Route Log- CustomLayout: ', location.pathname)
  const isNavTop = navType === NAV_TYPE_TOP

  return (
    <Layout>
      <HeaderNav />
      <TopNav routeInfo={currentRouteInfo} />
      <Layout className="app-container">
        <CMSContextProvider>
          <SideNav routeInfo={currentRouteInfo} />
          <Layout className="app-layout">
            <div className={`app-content ${isNavTop ? 'layout-top-nav' : ''}`}>
              <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
              <Content>
                <Switch>
                  <Route path="" component={views} />
                </Switch>
              </Content>
            </div>
            <Footer />
          </Layout>
        </CMSContextProvider>
      </Layout>
      <MobileNav />
    </Layout>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navType, locale } = theme
  return { navType, locale }
}

CustomLayout.propTypes = {
  navType: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  views: PropTypes.element.isRequired,
}

export default withRouter(connect(mapStateToProps)(CustomLayout))
